import { Box, type BoxProps } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

type LoadingSpinnerProps = {
  backgroundColor?: string;
  foregroundColor?: string;
  size?: number;
} & Omit<BoxProps<'svg'>, 'children' | 'component'>;

export function LoadingSpinner({
  backgroundColor = 'blues.extraLight',
  foregroundColor = 'blues.lighter',
  size = 24,
  ...props
}: LoadingSpinnerProps) {
  return (
    <Box
      {...props}
      aria-hidden="true"
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      sx={{
        width: size,
        height: size,
        animation: `${spin} 1s linear infinite`,
      }}
    >
      <Box
        component="path"
        d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M4.27 12a7.73 7.73 0 1 0 15.46 0 7.73 7.73 0 0 0-15.46 0"
        sx={{ color: backgroundColor, fill: 'currentColor' }}
      />
      <Box
        component="path"
        d="M21.836 18.875A12 12 0 0 0 7.79.763L9.287 4.76a7.73 7.73 0 0 1 9.05 11.668z"
        sx={{ color: foregroundColor, fill: 'currentColor' }}
      />
    </Box>
  );
}
